import { render, staticRenderFns } from "./localization-select.vue?vue&type=template&id=d5faf28e"
import script from "./localization-select.vue?vue&type=script&lang=js"
export * from "./localization-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports